import React from 'react';

const PageLayout = ({
  children,
  title,
  icon: Icon,
  actions,
  maxWidth = 'max-w-[100%]',
  className = '',
}) => {
  return (
    <main className={`p-3 sm:p-4 lg:p-6 overflow-x-auto ${className}`}>
      <div className={`${maxWidth} mx-auto w-full min-w-0`}>
        {(title || actions) && (
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
            {title && (
              <div className="min-w-0">
                <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold text-secondary flex items-center gap-2 sm:gap-3 truncate">
                  {Icon && <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-brand shrink-0" />}
                  <span className="truncate">{title}</span>
                </h1>
              </div>
            )}
            {actions && (
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 shrink-0 w-full sm:w-auto">
                {actions}
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </main>
  );
};

export default PageLayout;
